import { useEffect, useRef } from "react";
import { registerSmsProtocolHandler } from "../../utils/smsProtocolBridge";

export function useSmsProtocol(onSmsUrl: (url: string) => void, enabled = true) {
  const onSmsUrlRef = useRef(onSmsUrl);
  onSmsUrlRef.current = onSmsUrl;

  useEffect(() => {
    if (!enabled) return;
    return registerSmsProtocolHandler((url) => onSmsUrlRef.current(url));
  }, [enabled]);
}
